import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Input } from '@meindach/ui-kit';
import { Form, useField } from 'formik';
import { ErrorText } from '../../components/genericInput/styled';
import { Label, PasswordError } from './styled';

interface Props {
  isSending: boolean;
  error?: string;
}

export const PasswordResetForm: FC<Props> = ({ error, isSending }) => {
  const { t } = useTranslation('passwordReset');
  const [field, meta] = useField({ name: 'password' });
  return (
    <Form>
      {error && <ErrorText>{t(error)}</ErrorText>}
      <Label htmlFor={field.name}>{t('password')}</Label>
      <Input
        {...field}
        error={!!meta.error}
        placeholder={t('password')}
        type="password"
      />
      {meta.error && <PasswordError>{meta.error}</PasswordError>}
      <Button type="submit" disabled={isSending} small>
        {t('buttonText')}
      </Button>
    </Form>
  );
};
